import script from "./ModalEditarSigla.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEditarSigla.vue?vue&type=script&setup=true&lang=js"

import "./ModalEditarSigla.vue?vue&type=style&index=0&id=7adee9ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7adee9ea"]])

export default __exports__